import { getLocalTimeZone } from "@internationalized/date";
import { KdsDatePicker } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { type ControlledDatePickerProps } from "./ControlledDatePicker.types";

const ControlledDatePicker = ({
  name,
  ...inputProps
}: ControlledDatePickerProps) => {
  const { control, formState } = useFormContext();

  const error = formState.errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KdsDatePicker
          {...inputProps}
          errorMessage={error?.message?.toString()}
          hasError={!!error}
          label={inputProps.label}
          onChange={(value) => {
            const date = value?.toDate(getLocalTimeZone());
            field.onChange(date);
          }}
        />
      )}
    />
  );
};

export { ControlledDatePicker };
